"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppointmentDisplayItem =
/*
  title:string;
  titleExtra: string;
  active;
  nextDateText:string;
  nextDateFromNow:string
  icon:ScheduleIconName;
  appointment_id: number;
*/

function AppointmentDisplayItem(appt, mainPage) {
  _classCallCheck(this, AppointmentDisplayItem);

  this.appointment_id = appt.id;
  this.active = appt.isReady();

  this.title = appt.titleText(mainPage);

  this.titleExtra = mainPage ? appt.description : "";
  this.nextDateText = appt.displayDateTime();
  this.nextDateFromNow = appt.fromNow();
  this.icon = appt.getStatus();
};

var Appointment = function () {

  /*
    id: number;
    patientId: number;
    description: string;
    reminderBefore: number;
    reminderAfter: number;
    date: Date;
    dateStr: string;
    duration: number;
    appointmentType: string;
    hour: number;
    minute: number;
    completed;
  */

  function Appointment(json) {
    _classCallCheck(this, Appointment);

    this.id = parseInt(json["id"]);
    this.patientId = parseInt(json["patient_id"]);
    this.appointmentType = json["appointment_type"];
    this.description = json["description"];
    this.duration = parseInt(json["duration"]);
    this.reminderBefore = parseInt(json["reminder_before"]);
    this.reminderAfter = parseInt(json["reminder_after"]);

    this.dateStr = json["appointment_date"];
    this.hour = parseInt(json["hour"]);
    this.minute = parseInt(json["minute"]);
    this.date = moment.utc(json["appointment_date_time"]).toDate();

    this.completed = json["completed"] == "true";
  }

  _createClass(Appointment, [{
    key: "markComplete",
    value: function markComplete() {
      console.log(" markComplete");
      this.completed = true;
      Store.markAppointmentComplete(this.id);
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      if (this.completed) {
        return "done";
      } else if (this.isPast()) {
        return "missed";
      } else if (this.isReady()) {
        return "ready";
      } else {
        return "scheduled";
      }
    }
  }, {
    key: "titleText",
    value: function titleText(mainPage) {
      if (mainPage) {
        return $t("video.next_video_conference");
      } else if (this.description == null || this.description == "") {
        return $t("video.reminder_title");
      } else {
        return this.description;
      }
    }
  }, {
    key: "fromNow",
    value: function fromNow() {
      return formatNextDate(this.date) + " " + kanayo.date.formatTime(this.date);
    }
  }, {
    key: "displayDateTime",
    value: function displayDateTime() {
      return kanayo.date.formatDateTime(this.date);
    }
  }, {
    key: "displayTime",
    value: function displayTime() {
      return kanayo.date.formatTime(this.date);
    }
  }, {
    key: "isReady",
    value: function isReady() {
      var now = new Date();
      var start = moment(this.date).subtract(this.reminderBefore, 'minute').toDate();
      var end = moment(this.date).add(this.reminderAfter, 'minute').toDate();
      return now.getTime() >= start.getTime() && now.getTime() <= end.getTime();
    }
  }, {
    key: "isPending",
    value: function isPending() {
      var now = new Date();
      var end = moment(this.date).add(this.reminderAfter, 'minute').toDate();
      return !this.completed && now.getTime() <= end.getTime();
    }
  }, {
    key: "isScheduled",
    value: function isScheduled() {
      return !this.completed && !this.isPast();
    }
  }, {
    key: "isLate",
    value: function isLate() {
      var now = new Date();
      var end = moment(this.date).toDate();
      return now.getTime() > end.getTime();
    }
  }, {
    key: "isPast",
    value: function isPast() {
      var now = new Date();
      var end = moment(this.date).add(this.reminderAfter, 'minute').toDate();
      return now.getTime() > end.getTime();
    }
  }, {
    key: "reminderTime",
    value: function reminderTime() {
      return moment(this.date).subtract(this.reminderBefore, 'minute').toDate();
    }
  }], [{
    key: "nextApptForPatient",
    value: function nextApptForPatient(patientId) {
      return this.currentAppts.find(function (appt) {
        return appt.patientId === patientId && appt.isPending();
      });
    }
  }, {
    key: "allApptsForPatient",
    value: function allApptsForPatient(patientId) {
      return this.currentAppts.filter(function (appt) {
        return appt.patientId === patientId && appt.isScheduled();
      });
    }
  }, {
    key: "markAppointmentComplete",
    value: function markAppointmentComplete(apptId) {

      var appt = this.currentAppts.find(function (appt) {
        return appt.id === apptId;
      });
      console.log(appt);

      if (appt) {
        appt.markComplete();
      }
    }
  }, {
    key: "loadFromJson",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(json) {
        var oldRecords, completeLookup, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, rec, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, m, appt;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("loadFromJson");
                Appointment.currentAppts = [];

                _context.next = 4;
                return Store.getAppointments();

              case 4:
                oldRecords = _context.sent;
                completeLookup = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;

                for (_iterator = oldRecords[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  rec = _step.value;

                  if (rec.json.completed == true) {
                    completeLookup[rec.json.id] = true;
                  }
                }

                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](9);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 17:
                _context.prev = 17;
                _context.prev = 18;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 20:
                _context.prev = 20;

                if (!_didIteratorError) {
                  _context.next = 23;
                  break;
                }

                throw _iteratorError;

              case 23:
                return _context.finish(20);

              case 24:
                return _context.finish(17);

              case 25:
                console.log(completeLookup);

                _context.next = 28;
                return Store.clearAppointments();

              case 28:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 31;
                _iterator2 = json[Symbol.iterator]();

              case 33:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 43;
                  break;
                }

                m = _step2.value;

                console.log(m);
                if (completeLookup[m.id]) {
                  m.completed = "true";
                }

                _context.next = 39;
                return Store.saveAppointment(m);

              case 39:

                if (m.completed != "true") {
                  appt = new Appointment(m);

                  Appointment.currentAppts.push(appt);
                }

              case 40:
                _iteratorNormalCompletion2 = true;
                _context.next = 33;
                break;

              case 43:
                _context.next = 49;
                break;

              case 45:
                _context.prev = 45;
                _context.t1 = _context["catch"](31);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 49:
                _context.prev = 49;
                _context.prev = 50;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 52:
                _context.prev = 52;

                if (!_didIteratorError2) {
                  _context.next = 55;
                  break;
                }

                throw _iteratorError2;

              case 55:
                return _context.finish(52);

              case 56:
                return _context.finish(49);

              case 57:

                Appointment.currentAppts = Appointment.currentAppts.sort(Appointment.compare);

                return _context.abrupt("return", Appointment.currentAppts);

              case 59:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 13, 17, 25], [18,, 20, 24], [31, 45, 49, 57], [50,, 52, 56]]);
      }));

      function loadFromJson(_x) {
        return _ref.apply(this, arguments);
      }

      return loadFromJson;
    }()
  }, {
    key: "loadFromStore",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var records, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, rec, appt;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("load appts from store --");
                Appointment.currentAppts = [];
                _context2.next = 4;
                return Store.getAppointments();

              case 4:
                records = _context2.sent;

                console.log(records);

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context2.prev = 9;
                for (_iterator3 = records[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  rec = _step3.value;

                  console.log(rec);
                  appt = new Appointment(rec.json);

                  if (!appt.completed) {
                    Appointment.currentAppts.push(appt);
                  }
                }

                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](9);
                _didIteratorError3 = true;
                _iteratorError3 = _context2.t0;

              case 17:
                _context2.prev = 17;
                _context2.prev = 18;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 20:
                _context2.prev = 20;

                if (!_didIteratorError3) {
                  _context2.next = 23;
                  break;
                }

                throw _iteratorError3;

              case 23:
                return _context2.finish(20);

              case 24:
                return _context2.finish(17);

              case 25:
                Appointment.currentAppts = Appointment.currentAppts.sort(Appointment.compare);

                return _context2.abrupt("return", Appointment.currentAppts);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 13, 17, 25], [18,, 20, 24]]);
      }));

      function loadFromStore() {
        return _ref2.apply(this, arguments);
      }

      return loadFromStore;
    }()
  }, {
    key: "compare",
    value: function compare(a, b) {
      return a.date.getTime() - b.date.getTime();
    }
  }]);

  return Appointment;
}();

Appointment.currentAppts = [];